import { Image, ImageProps } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

function Logo(props: Partial<ImageProps>) {
  return (
    <Link to="/">
      <Image
        maxHeight={'35px'}
        {...(props as any)}
        src="/assets/logo.svg"
        alt={'pintora logo'}
      />
    </Link>
  );
}

export default Logo;
